import { useQuery } from "@tanstack/react-query";
import { resolveBulkContacts, ResolveBulkContactsResponse } from "../actions/resolvedBulkContactsVr.actions";

export type BulkResolvedContact = ResolveBulkContactsResponse[string];

export type BulkResolvedMap = ResolveBulkContactsResponse;

export const VR_BULK_RESOLVE_QUERY_KEY = ["contacts", "resolve-bulk"] as const;

const normalizePhones = (phones: string[]) => {
  return Array.from(
    new Set(
      phones
        .map((phone) => phone?.trim())
        .filter(Boolean),
    ),
  );
};

export const useVrBulkResolver = (
  companyId?: number | string | null,
  phones: string[] = [],
  enabled = true,
) => {
  const normalizedPhones = normalizePhones(phones);

  return useQuery<BulkResolvedMap>({
    queryKey: [...VR_BULK_RESOLVE_QUERY_KEY, companyId, normalizedPhones],
    queryFn: () =>
      resolveBulkContacts({
        companyId: companyId as number | string,
        phones: normalizedPhones,
      }),
    enabled: enabled && !!companyId && normalizedPhones.length > 0,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });
};
